import React from 'react';
import './message.css';
import moment from 'moment';
import {emojify} from 'react-emojione';

const Message = (props) => {
  const {
    createdDate,
    body,
    isMine,
    startsSequence,
    endsSequence,
    showTimestamp,
    sendingInProgress,
    ipAddress,
  } = props;

  const friendlyTimestamp = moment(createdDate).format('HH:mm');

  return (
    <div className={[
      'message',
      `${isMine ? 'mine' : ''}`,
      `${startsSequence ? 'start' : ''}`,
      `${endsSequence ? 'end' : ''}`
    ].join(' ')}>
      {sendingInProgress ?
        <div className="bubble-container withError">
          <div className="bubble" title={createdDate}>
            { body }
          </div>
          <div
            className="waitingCircle deliveryStatus"
          />
        </div> : <div className="bubble-container">
          <div className="bubble" title={ipAddress ? `${createdDate}\nIP: ${ipAddress}` : createdDate}>
            { emojify(body) }
          </div>
        </div>}
      {
        showTimestamp &&
        <div
          className={`timestamp under-bubble
          ${isMine ? ' justifyContentFlexEnd' :
            ' justifyContentFlexStart'}`}>
          { friendlyTimestamp }
          { ipAddress && (
            <span style={{ marginLeft: 6, opacity: 0.6, fontSize: '0.85em' }}>
              {`· ${ipAddress}`}
            </span>
          )}
        </div>
      }
    </div>
  );
};

export default Message;
